<div class="blocChrono" *ngIf="chronos !== null && chronos.length > 0">
  <ion-grid>
    <ion-row>
      <div
        class="bottom_bar position_{{ realIndex }} {{ chronos[realIndex].typeActiviteInterne }}"
        *ngIf="chronos.length === 2"
      ></div>
      <ion-col
        class="blocLibelle col {{ chrono.typeActiviteInterne }} position_{{ i }}"
        [class.activeChrono]="realIndex === i"
        *ngFor="let chrono of chronos; let i = index"
        (click)="clickChronoOt(chrono)"
      >
        <span *ngIf="chrono.libelleOt" class="{{ chrono.activeChrono }}">{{ chrono.libelleOt }}</span>
        <span *ngIf="chrono.unplanned" class="{{ chrono.activeChrono }}">OT non planifié</span>
      </ion-col>
    </ion-row>
  </ion-grid>

  <swiper-container id="slider-chronos" init="false" (swiperslidechangetransitionend)="slideChanged()">
    <swiper-slide *ngFor="let chrono of chronos; let i = index">
      <div class="itemChrono">
        <div class="left">
          <div class="itemChrono__blocText">
            <p class="itemChrono__blocText--text">
              <small>{{ chrono.state }}</small>
            </p>
            <p class="itemChrono__blocText--small">
              <small>{{ chrono.site_name }}</small>
            </p>
          </div>
        </div>
        <div class="right itemChrono__buttons">
          <ion-button class="itemChrono__button" (click)="startStop(chrono.idOt, 'travel', chrono.id_site)">
            <div>
              <div class="itemChrono__button__icon itemChrono__button_icon_container">
                <ion-icon name="car" class="itemChrono__button--car"></ion-icon>
                <ion-icon
                  [name]="chrono.active_travel || chrono.active_return_travel ? 'pause' : 'play'"
                  class="itemChrono__button--playPause"
                  [ngClass]="
                    chrono.active_travel || chrono.active_return_travel
                      ? 'itemChrono__button--pause'
                      : 'itemChrono__button--play'
                  "
                ></ion-icon>
              </div>
              <div
                class="sti-icon"
                *ngIf="
                  (chrono.isStiCreated &&
                    !chrono.active_intervention &&
                    (chrono.active_travel ||
                      chrono.active_return_travel ||
                      chrono.state === 'En déplacement (pause)')) ||
                  (chrono.isSiu && !chrono.active_intervention) ||
                  (chrono.isStiCreated && !chrono.state)
                "
                [ngClass]="{
                  'sti-icon__in-progress': chrono.active_travel || chrono.active_return_travel,
                }"
              >
                STI
              </div>
            </div>
          </ion-button>
          <ion-button class="itemChrono__button" (click)="startStop(chrono.idOt, 'intervention', chrono.id_site)">
            <div>
              <div class="itemChrono__button__icon itemChrono__button_icon_container">
                <ion-icon name="build" class="itemChrono__button--build"></ion-icon>
                <ion-icon
                  [name]="chrono.active_intervention ? 'pause' : 'play'"
                  class="itemChrono__button--playPause itemChrono__button--playPause--intervention"
                  [ngClass]="chrono.active_intervention ? 'itemChrono__button--pause' : 'itemChrono__button--play'"
                ></ion-icon>
              </div>
              <div
                class="sti-icon"
                [ngClass]="{
                  'sti-icon__in-progress': chrono.active_intervention,
                }"
                *ngIf="
                  chrono.typeChrono === TypeChrono.Ot &&
                  chrono.isStiCreated &&
                  (chrono.state === 'En intervention (pause)' || chrono.state === 'En intervention')
                "
              >
                STI
              </div>
            </div>
          </ion-button>
          <ion-button class="itemChrono__button" (click)="stop(chrono.id_site, chrono.idOt)">
            <div class="itemChrono__button__icon">
              <ion-icon name="square" class="itemChrono__button--stop"></ion-icon>
            </div>
          </ion-button>
          <ion-button class="itemChrono__button more-button" (click)="onMoreClick($event, chrono)">
            <div class="itemChrono__button__icon">
              <ion-icon name="ellipsis-vertical"></ion-icon>
            </div>
          </ion-button>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
</div>
